export default "__VITE_ASSET__de662006__"